import {
	fileViewerPluginName,
	watermarkEvents,
	WatermarkTransformResponse,
} from '@sharefiledev/fileviewer-pilet-sdk';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { t } from '../../translate';
import { getCustomWatermarkingLabels } from '../../utils/getCustomLablesForWatermarking';
import { createWatermarkResource } from '../WatermarkCheckBox/watermarkResourceService';

export function setupWatermarkEventService(piletApi: PiletApi) {
	const disposers: (() => void)[] = [];

	const handleWatermarkRequest = async (data: { resourceIds: string[] }) => {
		try {
			const result = await createWatermarkResource(data.resourceIds);

			const response: WatermarkTransformResponse = {
				transformedRids: result.success ? result.resourceRIDs : [],
				success: result.success,
				labels: getCustomWatermarkingLabels(t),
				pluginName: fileViewerPluginName,
			};

			piletApi.emit(watermarkEvents.TransformedRidsResponse, response);
		} catch (error) {
			const errorResponse: WatermarkTransformResponse = {
				transformedRids: [],
				success: false,
				labels: getCustomWatermarkingLabels(t),
				pluginName: fileViewerPluginName,
			};

			piletApi.emit(watermarkEvents.TransformedRidsResponse, errorResponse);
		}
	};

	// Register event listener
	piletApi.on(watermarkEvents.GetTransformedRids, handleWatermarkRequest);

	// Store disposer
	disposers.push(() =>
		piletApi.off(watermarkEvents.GetTransformedRids, handleWatermarkRequest)
	);

	// Return a cleanup function
	return function disposeWatermarkEventService() {
		disposers.forEach(dispose => dispose());
		disposers.length = 0;
	};
}
